import React from "react";
import { IPromotionProps } from "../../../types/suggestion-items";
import { ITelemetryData, TelemetryContentEnum } from "../../../types/telemetry";
import { sendTelemetryData } from "../../../util/events/telemetry";
import { setStoredSearchQuery } from "../../../util/queryStorage";
import { useNavigationContext } from "../../../util/contexts";
import ChevronRight from "../../../Assets/svg/Chevron_right_icon";
import "./promotion.scss";

const Promotion = (props: IPromotionProps) => {
    const { handleMouseSelect, handleMouseDeselect, handleTouched } = useNavigationContext();

    const headline = props.promotion.headline;
    const buttonCTA = props.promotion.cta;
    const buttonLink = props.promotion.link.replace("?", "?itemorigin=SEARCH&");
    const logoUrl = createCdnUrl();

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event?.preventDefault();
        handleTouched(props.promotion.navIndex);
        recordFeaturePromotionUsed();
        setStoredSearchQuery({
            name: buttonCTA,
            target: props.promotion.link
        });
        window.location.href = props.promotion.link;
    };

    const recordFeaturePromotionUsed = () => {
        const data: ITelemetryData = {
            correlationId: props.searchInfo.pageViewLogDataId,
            culture: props.searchInfo.culture,
            portal: props.searchInfo.portal,
            searchTerm: props.searchInfo.searchTerm,
            shortLink: props.promotion.shortLink,
            suggestion: props.promotion.name,
            contentType: TelemetryContentEnum.FeaturePromotion
        };

        sendTelemetryData(data, props.searchInfo.trackingEndpoint);
    };

    function createCdnUrl(): string {
        const origin = window.location.origin;
        const startIndex = props.promotion.logoUrl.indexOf("/documents/");
        let assetLocation = props.promotion.productFinderLogoBasePathPreview;

        if (origin.indexOf("preview") < 0) {
            assetLocation = props.promotion.productFinderLogoBasePathRelease;
        }

        return `${assetLocation}${props.promotion.logoUrl.substring(startIndex)}`;
    }

    return (
        <div className={"feature-promotion " + props.style}>
            <div className="promotion-logo-container">
                <img className="promotion-logo" src={logoUrl} alt={buttonCTA} />
            </div>
            <div className="promotion-headline-container">
                <div className="promotion-headline-inner-container">
                    <span className="promotion-headline">{headline}</span>
                </div>
            </div>
            <div
                ref={props.setRef}
                onMouseEnter={() => handleMouseSelect(props.promotion.navIndex)}
                onMouseLeave={handleMouseDeselect}
                className="promotion-button-container"
            >
                <a
                    className="promotion-button"
                    href={buttonLink}
                    onClick={handleClick}
                    data-testid={`ssw-button-${props.promotion.name.toLowerCase()}`}
                    data-semantic-id={`ssw-button-${props.promotion.name.toLowerCase()}`}
                >
                    <div className="promotion-button-text">
                        <div className="promotion-button-content">{buttonCTA}</div>
                        <div className="promotion-button-icon">
                            <ChevronRight />
                        </div>
                    </div>
                </a>
            </div>
        </div>
    );
};

export default Promotion;
